import type {
  Configuration,
  ViewsConfiguration,
  BackgroundOptions,
  ChatbotData,
  NewsConfig
} from '@davi-ai/retorik-framework'

const defaultTimeoutMilliseconds = 5000;
const defaultTimeoutSeconds = 5;
const defaultVeilleTime = 180;

export type {
  Configuration,
  ViewsConfiguration,
  BackgroundOptions,
  ChatbotData,
  NewsConfig
}

export {
    defaultTimeoutMilliseconds,
    defaultTimeoutSeconds,
    defaultVeilleTime
}